import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { Button, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './CreditsUnlocked.module.scss';
const introStepTextsPath = 'vendorOnboarding.introStep';
export const CreditsUnlocked = (param)=>{
    let { onComplete, isMobile } = param;
    const { t } = useLocaleKeys(introStepTextsPath);
    return /*#__PURE__*/ _jsxs(motion.div, {
        className: clsx(styles.root, isMobile && styles.mobile),
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        transition: {
            delay: 0.2,
            duration: 0.4
        },
        children: [
            /*#__PURE__*/ _jsx(motion.div, {
                initial: {
                    opacity: 0,
                    y: 20
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                transition: {
                    delay: 0.2,
                    duration: 0.5
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "h3",
                    fontFamily: "hero",
                    weight: "bold",
                    className: styles.headline,
                    children: t.creditsUnlocked()
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                initial: {
                    opacity: 0
                },
                animate: {
                    opacity: 1
                },
                transition: {
                    delay: 0.7,
                    duration: 0.4
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph1",
                    children: t.creditsDescription()
                })
            }),
            /*#__PURE__*/ _jsx(motion.div, {
                initial: {
                    opacity: 0,
                    y: 12
                },
                animate: {
                    opacity: 1,
                    y: 0
                },
                transition: {
                    delay: 0.7,
                    duration: 0.5,
                    type: 'spring',
                    stiffness: 300,
                    damping: 20
                },
                children: /*#__PURE__*/ _jsx(Button, {
                    skin: "primary",
                    className: styles.button,
                    onClick: onComplete,
                    children: t.getStarted()
                })
            })
        ]
    }, "credits");
};
